/**
 * @description Sidebar navigation for LynxPay Sales Organization users
 *
 * @param {boolean} isSidebarOpen - Whether sidebar is expanded (for label visibility)
 * @param {Function} onLinkClick - Callback when a link is clicked (used to close mobile sidebar)
 * @param {boolean} isMobile - Whether rendering in mobile mode
 *
 * @notes Pack SO mounts PackSOSidebar instead. This file stays LynxPay:
 *   Dashboard / Transactions / Merchants / Reporting.
 */

import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Home, CreditCard, Store, BarChart3 } from 'lucide-react';

const SOSidebar = ({ isSidebarOpen, onLinkClick, isMobile = false }) => {
  const soLinks = useMemo(() => ([
    { to: '/so/dashboard', label: 'Dashboard', icon: Home },
    { to: '/so/transactions', label: 'Transactions', icon: CreditCard },
    { to: '/so/merchants', label: 'Merchants', icon: Store },
    { to: '/so/reporting', label: 'Reporting', icon: BarChart3 }
  ]), []);

  return (
    <>
      {soLinks.map((link) => (
        <Link
          key={link.to}
          to={link.to}
          className="group relative flex items-center py-3 rounded-lg text-gray-300 hover:bg-gray-800 hover:text-white transition-colors duration-200"
          onClick={() => isMobile && onLinkClick && onLinkClick()}
        >
          <div className="w-12 flex items-center justify-center flex-shrink-0">
            <link.icon className="w-5 h-5" />
          </div>

          <span className={`text-sm font-medium overflow-hidden whitespace-nowrap transition-all duration-300 ${
            isMobile ? 'opacity-100 max-w-full' : isSidebarOpen ? 'opacity-100 max-w-full delay-[50ms]' : 'opacity-0 max-w-0'
          }`}>
            {link.label}
          </span>

          {!isMobile && !isSidebarOpen && (
            <div className="absolute left-14 top-1/2 -translate-y-1/2 bg-gray-800 text-white px-2 py-1 rounded opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap z-50 pointer-events-none">
              {link.label}
            </div>
          )}
        </Link>
      ))}
    </>
  );
};

export default SOSidebar;
